import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { constant } from '../../app.constants';
import {
  IDriver,
  IReasonChangeStatus,
  IBulkLicenseUploadResponse,
  ISendToRide2MdResponse,
  IUpdateActiveBackGroundCheckRequest,
  IUploadProfilePhotoResponse,
  IDriverDocumentImportResponse
} from '../../core/interfaces/driver.interface';
import { ICurrentLocationDriver } from '../../core/models/driver.model';
import { ITripRouteDetails } from '../../core/interfaces/schedule-trip.interface';
import { IJobsPortalEmployeeLookupResponse } from '../../core/interfaces/jobs-portal-employee.interface';
import { DriverNoteModel, DriverNoteResponse } from './models/driver-notes.model';
import { map } from 'rxjs/operators';
import { UploadsService } from '../A2-utils/uploads.service';

@Injectable()
export class DriversService extends ParentService {

  private provStatusInput = new BehaviorSubject<boolean>(null);
  provStatusInput$ = this.provStatusInput.asObservable();

  private providerId = new BehaviorSubject<number>(null);
  providerId$ = this.providerId.asObservable();

  private driverPermissions = new BehaviorSubject<any>(null);
  driverPermissions$ = this.driverPermissions.asObservable();

  private driverId = new BehaviorSubject<number>(null);
  driverId$ = this.driverId.asObservable();

  constructor(
    private _http: Http,
    private uploadsService: UploadsService,
  ) {
    super();
  }

  sendProvStatusInput(change: boolean) {
    this.provStatusInput.next(change);
  }

  /**
   * @name getTimeNow
   * @description
   */
  getTimeNow() {
    return this._http
      .get(constant.URL_DATE_TIME_NOW, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getProfileLogMCT
   * @description
   * @param driverId
   */
  getProfileLogMCT(driverId: number) {
    const url = `${constant.LIST_URL_PROFILE_LOG}/${driverId}`;
    return this._http
      .get(url, this.getHeader())
      .pipe(map((response: any) => response.json()))
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getLicensesTypeMCT
   * @description
   */
  getLicensesTypeMCT() {
    return this._http
      .get(constant.LIST_URL_LICENSES_TYPE, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getLicensesMCT
   * @description
   * @param driverid
   * @param showInactive
   */
  getLicensesMCT(driverid: number, showInactive: boolean): Observable<any> {
    const url = `${constant.LIST_URL_LICENSES}/${driverid}/${showInactive}`;
    return this._http
      .get(url, this.getHeader())
      .pipe(map((response: any) => response.json()))
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getPendingDocumentsCount
   * @description How many documents TA Portal holds for this driver that have not been imported.
   * @param driverid
   */
  getPendingDocumentsCount(driverid: number): Observable<number> {
    const url = `${constant.URL_PENDING_DOCUMENTS_COUNT}/${driverid}`;
    return this._http
      .get(url, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name importPendingDocuments
   * @description Imports those documents as licences on the driver.
   * @param driverid
   */
  importPendingDocuments(driverid: number): Observable<IDriverDocumentImportResponse> {
    const url = `${constant.URL_IMPORT_PENDING_DOCUMENTS}/${driverid}`;
    return this._http
      .post(url, null, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getEtaDriver
   * @description trae tiempo de driver not on demand
   * @param driverid
   * @param tripid
   */
  getEtaDriver(driverid, tripid) {
    return this._http.get(constant.URL_DRIVER_ETA + '/' + driverid + '/' + tripid, this.getHeader())
      .map(res => res.json());
  }

  sendToTrip2(data: any): Observable<ISendToRide2MdResponse> {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_SEND_DRIVER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }



  /**
   * @name getDocumentsMCT
   * @description
   * @param driverid
   */
  getDocumentsMCT(driverid: number): Observable<any> {
    const url = `${constant.LIST_URL_DOCUMENTS}/${driverid}`;
    return this._http
      .get(url, this.getHeader())
      .pipe(map((res: any) => res.json()))
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getStatusDriverProvider
   * @description
   */
  getStatusDriverProvider() {
    return this._http
      .get(constant.URL_DRIVER_STATUS_PROVIDER, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getLog
   * @param driverid
   */
  getLog(driverid: Number): Observable<any> {
    const url = `${constant.URL_USER_DEVICE}/${driverid}`;
    return this._http
      .get(url, this.getHeader())
      .pipe(map((response: any) => response.json()))
      .catch((error) => Observable.throw(error.json()));
  }

  /**
   * @name getDriverHistoy
   * @param driverid
   */
  getDriverHistoy(driverid) {
    return this._http
      .get(constant.URL_DRIVER_HISTORY + '/' + driverid, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getDriversMCT
   * @param {number} driverid
   */
  getDriversMCT(driverid: number) {
    return this._http
      .get(constant.URL_DRIVERS + '/' + driverid, this.getHeader())
      .map(res => res.json());
  }
  /**
   * @name getDriversMCT
   * @param {number} driverid
   */
  getCurrentLocationDriver(driverid: number): Observable<ICurrentLocationDriver> {
    return this._http
      .get(constant.URL_CURRENT_LOCATION_BY_DRIVER + '/' + driverid, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getDriversMCTAll
   * @description
   */
  getDriversMCTAll() {
    return this._http
      .get(constant.LIST_URL_DRIVERS, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getDriversProviderAll
   * @description
   */
  getDriversProviderAll() {
    return this._http
      .get(constant.LIST_URL_DRIVERS_PROVIDER + '/?filter=&showInactive=false', this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getTripRoute
   * @param tripid
   */
  getTripRoute(tripid) {
    return this._http
      .get(constant.URL_GET_TRIP_LOCATION + tripid, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getFilterDriver
   * @description
   * @param filter
   * @param showDisable
   */
  getFilterDriver(filter, showDisable) {
    return this._http
      .get(constant.URL_DRIVERS + '/' + filter + '/' + showDisable, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getDriverLastLocation
   * @description
   * @param id
   */
  getDriverLastLocation(id) {
    return this._http
      .get(constant.URL_DRIVER_LASTLOCATION + id, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getDriverVehicleInfo
   * @description
   * @param id
   */
  getDriverVehicleInfo(id) {
    return this._http
      .get(constant.URL_VEHICLE_BY_DRIVER + '/' + id, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getDriverETA
   * @description
   * @param origin
   * @param destination
   */
  getDriverETA(origin, destination) {
    return this._http
      .get(
        constant.URL_DISTANCE_MATRIX +
        '?origins=' + origin.lat + ',' + origin.lng +
        '&destinations=' + destination.lat + ',' + destination.lng, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name postDriverLicense
   * @description
   * @param {any} data
   */
  postDriverLicense(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.POST_URL_DRIVER_LIC, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /**
   * @name uploadBulkLicenses
   * @description Uploads multiple license PDF files in one batch request
   * @param {File[]} files
   */
  uploadBulkLicenses(files: File[]): Observable<number | IBulkLicenseUploadResponse> {
    return this.uploadsService.makeFileRequest(constant.POST_URL_DRIVER_LIC_BULK, [], files);
  }

  /**
   * @name putDriverLicense
   * @description
   * @param {any} data
   */
  putDriverLicense(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_UPDATE_DRIVER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /**
   * @name extractLicenseDocument
   * @description Runs the TA Portal document extraction for a driver license
   * @param {number} mctDriverLicenseId
   */
  extractLicenseDocument(mctDriverLicenseId: number) {
    const bodyString = JSON.stringify({ mctdriverlicenseid: mctDriverLicenseId });
    return this._http
      .post(constant.URL_EXTRACT_LICENSE_DOCUMENT, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name postDriverDocument
   * @description
   * @param {any} data
   */
  postDriverDocument(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.POST_URL_DRIVER_DOC, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /**
   * @name postDriversData
   * @param {any} data
   */
  postDriversData(data: any, createdFromEsoPortal?: boolean) {
    const bodyString = JSON.stringify(data);
    const url = createdFromEsoPortal
      ? `${constant.URL_CREATE_DRIVER}?createdFromEsoPortal=true`
      : constant.URL_CREATE_DRIVER;
    return this._http
      .post(url, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name postData
   * @description
   * @param {any} data
   */
  postData(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_DRIVERS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putData
   * @description
   * @param {any} data
   */
  putData(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_DRIVERS, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name putUpdateDriver
   * @description
   * @param {any} data
   */
  putUpdateDriver(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_UPDATE_DRIVER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /**@name changeStatusDriver
   * @description Adiciona la reason for change of status
   * @param id = driverid. data = data del reason
   * @param data
   */
  changeStatusDriver(id: Number, data: IReasonChangeStatus) {
    const body = JSON.stringify(data);
    return this._http.put(`${constant.URL_DRIVERS}/${id}/ChangeStatus`, body, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
  /**
   * @name deleteData
   * @description
   * @param {any} data
   */
  deleteData(data: any) {
    return this._http
      .delete(`${constant.URL_DRIVERS}/${data}`, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Server error'));
  }

  /**
   * @name validDriver
   * @description Valid driver
   * @param driverid
   */
  validDriver(driverid) {
    return this._http
      .get(constant.URL_VALID_MCT_DRIVERS + driverid, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name sendMessage
   * @description send message end point
   * @param data
   */
  sendMessage(data) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_SEND_MESSSAGE, bodyString, this.headerPost())
      .map((res: Response) => res.json(), (error: Response) => error.json());
  }

  /**
   * @name getFilterDriverMCT
   * @description
   * @param filter
   * @param showDisable
   */
  getFilterDriverMCT(filter?, showDisable?) {
    return this._http
      .get(constant.URL_DRIVERS + '/ListByFilter?filter=' + filter + '&showInactive=' + showDisable, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name qualificationIdSuffix
   * @description
   * @param qualificationId
   */
  private qualificationIdSuffix(qualificationId?: number | string): string {
    return qualificationId ? '&qualificationId=' + qualificationId : '';
  }

  private depotIdsSuffix(depotIds?: number[]): string {
    return depotIds && depotIds.length
      ? depotIds.map((depotId: number) => '&depotIds=' + depotId).join('')
      : '';
  }

  /**
   * @name  getDriversByProviderId
   * @description
   * @param filter
   * @param showDisable
   * @param providerid
   * @param providerDriverStatusId
   * @param qualificationId
   * @param depotIds
   */
  getDriversByProviderId(filter?, showDisable?, providerid?, providerDriverStatusId?, qualificationId?: number | string,
    depotIds?: number[]
  ) {
    return this._http
      .get(
        constant.LIST_URL_DRIVERS_PROVIDER
        + '/?filter='
        + filter
        + '&showInactive='
        + showDisable
        + '&providerid='
        + providerid
        + '&providerDriverStatusId='
        + providerDriverStatusId
        + this.qualificationIdSuffix(qualificationId)
        + this.depotIdsSuffix(depotIds),
        this.getHeader()
      )
      .map(res => res.json());
  }

  /**
   * @name getDriversByTaPortalCostCenter
   * @description get drivers filtered by a TA Portal cost center
   * @param taPortalCostCenterId
   * @param showDisable
   * @param providerDriverStatusId
   * @param providerId
   * @param qualificationId
   * @param depotIds
   */
  getDriversByTaPortalCostCenter(
    taPortalCostCenterId: number,
    showDisable: boolean,
    providerDriverStatusId: number | string,
    providerId: number | string,
    qualificationId?: number | string,
    depotIds?: number[]
  ): Observable<IDriver[]> {
    return this._http
      .get(
        constant.LIST_URL_DRIVERS_BY_TA_PORTAL_COST_CENTER
        + '/' + taPortalCostCenterId
        + '?showInactive=' + showDisable
        + '&providerDriverStatusId=' + providerDriverStatusId
        + '&providerId=' + providerId
        + this.qualificationIdSuffix(qualificationId)
        + this.depotIdsSuffix(depotIds),
        this.getHeader()
      )
      .map(res => res.json())
      .catch((error: Response) => Observable.throw(error.json()));
  }

  /**
   * @name getDriverByProvider
   * @description get drivers filter by provider
   */
  getDriverByProvider(providerid) {
    return this._http
      .get(constant.URL_GET_DRIVER_BY_PROVIDER + providerid, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getDriversProviderAll
   * @description
   */
  getDriversProviderAllByProvider(providerid, inactive?: boolean) {
    const act: boolean = inactive ? inactive : false;
    return this._http
      .get(`${constant.LIST_URL_DRIVERS_PROVIDER}/?filter=&providerid=${providerid}&showInactive=${act}`, this.getHeader())
      .map(res => res.json());
  }

  getTripHistoryDetail(tripid) {
    return this._http.get(constant.URL_TRIP_HISTORY_DETAIL + '/' + tripid, this.getHeader()).map(res => res.json());
  }

  verifyDriverLicense(userId: number) {
    const url = `${constant.URL_VERIFY_LICENSE_DRIVER}/${userId}`;
    return this._http
      .get(url, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  verifyDriverLicenseMassive(driverIds: number[]) {
    return this._http
      .post(constant.URL_POST_VERIFYLICENSE_MASSIVE, driverIds, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getZones() {
    return this._http
      .get(constant.URL_GETZONES, this.getHeader())
      .map(res => res.json());
  }

  /**
   * @name getTripRouteDetails
   * @description information trip route driver details
   * @param tripId
   */
  getTripRouteDetails(tripId: number): Observable<ITripRouteDetails> {
    return this._http.get(`${constant.URL_TRIP_ROUTE_DETAILS}/${tripId}`, this.getHeader()).map(res => res.json());
  }

  sendDriverVideo(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_SEND_VIDEO_DRIVER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
  getReportsDriver(driverid: number) {
    return this._http
      .get(
        constant.URL_GET_REPORTS + '/' + driverid,
        this.getHeader()
      )
      .map((res) => res.json())
      .catch(error => Observable.throw(error.json()));
  }
  getReportInfoDriver(reportid: string) {
    return this._http
      .get(
        constant.URL_GET_REPORT_INFO + '/' + reportid,
        this.getHeader()
      )
      .map((res) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  runBackgroundCheckDriver(id: number) {
    return this._http
      .post(
        constant.URL_RUN_BACKGROUND + '/' + id,
        null,
        this.headerPost()
      )
      .map((res: Response) => res.json())
      .catch((error: Response) => Observable.throw(error.json()));
  }

  updateActive(data: IUpdateActiveBackGroundCheckRequest) {
    return this._http
      .put(constant.URL_UPDATE_ACTIVE, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch(error => Observable.throw(error.json()));
  }

  setProviderId(providerId: number): void {
    this.providerId.next(providerId);
  }

  setDriverPermissions(permissions: any): void {
    this.driverPermissions.next(permissions);
  }

  setDriverId(driverId: number): void {
    this.driverId.next(driverId);
  }

  public reactivateAccount(driverId: number): Observable<any> {
    const url = `${constant.URL_REACTIVE_ACCOUNT_MTCDRIVER}/${driverId}`;
    return this._http
      .put(url, {}, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  checkEmployeeId(
    value: string,
    driverId?: number,
  ): Observable<{ data: boolean }> {
    let url = constant.URL_CHECK_EMPLOYEE_ID + value;
    if (driverId) {
      url = url + '?excludeDriverId=' + driverId;
    }
    return this._http
      .get(url, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  lookupEmployee(employeeId: string): Observable<IJobsPortalEmployeeLookupResponse> {
    const url = constant.URL_EMPLOYEE_LOOKUP + employeeId;
    return this._http
      .get(url, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  uploadProfilePhoto(driverId: number, photo: string): Observable<IUploadProfilePhotoResponse> {
    const bodyString = JSON.stringify({ photo: photo });
    return this._http
      .put(
        constant.URL_MCT_DRIVER_PHOTO + '/' + driverId,
        bodyString,
        this.headerPost(),
      )
      .map((res: Response) => res.json() as IUploadProfilePhotoResponse)
      .catch((error: any) => Observable.throw(error.json()));
  }

  getDriverNotes(driverId: number): Observable<DriverNoteModel[]> {
    return this._http
      .get(constant.URL_DRIVER_NOTES + '/Driver/' + driverId, this.getHeader())
      .map((res: Response) => res.json() as DriverNoteModel[])
      .catch((error: any) => Observable.throw(error.json()));
  }

  createDriverNote(driverId: number, data: DriverNoteModel): Observable<DriverNoteResponse> {
    data.driverid = driverId;
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_DRIVER_NOTES, bodyString, this.headerPost())
      .map((res: Response) => res.json() as DriverNoteResponse)
      .catch((error: any) => Observable.throw(error.json()));
  }

  updateDriverNote(driverId: number, data: DriverNoteModel): Observable<DriverNoteResponse> {
    data.driverid = driverId;
    const bodyString = JSON.stringify(data);
    return this._http
      .put(constant.URL_DRIVER_NOTES, bodyString, this.headerPost())
      .map((res: Response) => res.json() as DriverNoteResponse)
      .catch((error: any) => Observable.throw(error.json()));
  }

  deleteDriverNote(driverId: number, noteId: number): Observable<DriverNoteResponse> {
    return this._http
      .delete(constant.URL_DRIVER_NOTES + '/' + noteId, this.headerPost())
      .map((res: Response) => res.json() as DriverNoteResponse)
      .catch((error: any) => Observable.throw(error.json()));
  }

  postSaveLayout(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http
      .post(constant.URL_SAVE_LAYOUT, bodyString, this.headerPost())
      .map((res: Response) => res.json() as DriverNoteResponse)
      .catch((error: any) => Observable.throw(error.json()));
  }

  getRoleActionByModule(id: number) {
    return this._http
      .get(constant.URL_GETMODULEACTION + '/' + id, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/drivers/drivers.service.ts